import { IStyleProps } from './Interface'
import { makeStyles, Theme } from '@material-ui/core/styles'

export default makeStyles<Theme, IStyleProps>(theme => ({
  root: {
    verticalAlign: 'middle',
    display: 'inline-block'
  },
  addButton: ({ color }) => ({
    color,
    border: `1px solid ${color}`,
    backgroundColor: theme?.palette?.common?.grey,
    fontSize: '1rem',
    '&:hover': {
      borderColor: 'transparent',
      backgroundColor: theme?.palette?.common?.lightGrey
    }
  }),
  backdrop: {
    backdropFilter: 'blur(2px)'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '30px',
    width: 400,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    position: 'absolute'
  },
  buttonContainer: {
    marginTop: 10,
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    '& > *': {
      marginRight: 5
    }
  },
  inputContainer: {
    width: '100%'
  },
  labelContainer: {
    '& label': {
      color: theme?.palette?.common?.purple,
      fontSize: '1rem'
    }
  },
  freeTextRoot: {
    width: '100%'
  },
  selectLabel: {
    fontSize: '1rem'
  }
}))
